import { AxiosError } from 'axios'

import { UseAgentError } from 'hooks/use-agent'

export function instanceOfError(
  object: Error | AxiosError | UseAgentError
): object is Error {
  return object && (object as Error).message !== undefined
}

export function instanceOfAxiosError(
  object: Error | AxiosError | UseAgentError
): object is AxiosError {
  return object && (object as AxiosError).isAxiosError !== undefined
}
